import React, {useRef} from "react";
import styled from "styled-components";
import LabelWithTooltip, {LABEL_CONTAINER_CLASS, labelLayoutStyles} from "widgets/components/LabelWithTooltip";
import {LabelPosition} from "components/constants";
import _ from "lodash";
import {uuid2} from "@byk/utils/Utils";
import EditableTableComponent from "./EditableTableComponent";
import { SERVICE_BATCH_DATA } from "ce/sagas/ActionExecution/SetWidgetValue";

interface ContainerProps {
  compactMode: boolean;
  labelPosition?: LabelPosition;
  textColorBody?: string,
  textSizeHead?: string,
  textColorHead?: string,
  backgroundHead?: string,
  backgroundBody1?: string,
  backgroundBody2?: string,
  backgroundMouseOver?: string,
  horizontalAlignmentHead?: string,
  verticalAlignmentHead?: string,
  horizontalAlignmentBody?: string,
  verticalAlignmentBody?: string,
  fontStyleHead?: string,
  fontStyleBody?: string,
  isZebraStripe?: boolean,
  boxShadow?: string,
  borderRadius?: string,
  variant?: string,
  borderColor?: string,
  borderWidth?: string,
  textSizeBody?: string,
  accentColor: string,
}

const DivContainer = styled.div<ContainerProps>`
  ${labelLayoutStyles}
  & .${LABEL_CONTAINER_CLASS} {
    align-self: center;
    ${({labelPosition}) =>
      labelPosition === LabelPosition.Left && "min-height: 30px"};
  }

  .ant-table-body,
  .ant-table-body-inner {
    &::-webkit-scrollbar {
      width: 0;
    }
  }

  .ant-table-cell-scrollbar {
    display: none;
  }

  table {
    border: none !important;
  }

  table, th, td, .ant-table-container {
    border: none !important;
  }

  .ant-table-body {
    overflow: auto !important;
  }

  .ant-pagination a {
    color: ${({textColorBody}) => textColorBody} !important;
  }

  .ant-pagination .ant-pagination-item-active a {
    color: #40a9ff !important;
  }

  .ant-pagination .ant-pagination-item-link {
    color: ${({textColorBody}) => textColorBody} !important;
  }

  .ant-form-item-explain {
    position: absolute;
    left: 0 !important;
    color: red;
    font-size: 14px;
    padding-left: 10px; /* 根据需要调整 */
  }

  thead {
    background: ${({backgroundHead}) => backgroundHead || "#fafafa"} !important;

    th:last-child {
      background: ${({backgroundHead}) => backgroundHead || "#fafafa"} !important;
    }

    th:first-child {
      background: ${({backgroundHead}) => backgroundHead || "#fafafa"} !important;
    }
  }

  .ant-table-thead tr, .ant-table-thead th {
    background: transparent !important;
  }

  th {
    font-size: ${({textSizeHead}) => textSizeHead} !important;
    color: ${({textColorHead}) => textColorHead} !important;
    font-weight: ${({fontStyleHead}) => fontStyleHead && fontStyleHead.split(',')[0]} !important;
    font-style: ${({fontStyleHead}) => fontStyleHead && fontStyleHead.split(',')[1]} !important;
    text-align: ${({horizontalAlignmentHead}) => horizontalAlignmentHead} !important;
  }

  tbody td {
    font-size: ${({textSizeBody}) => textSizeBody} !important;
    color: ${({textColorBody}) => textColorBody} !important;
    font-weight: ${({fontStyleBody}) => fontStyleBody && fontStyleBody.split(',')[0]} !important;
    font-style: ${({fontStyleBody}) => fontStyleBody && fontStyleBody.split(',')[1]} !important;
    text-align: ${({horizontalAlignmentBody}) => horizontalAlignmentBody} !important;
  }

  ${({boxShadow}) => `
    .ant-table-container{
      box-shadow: ${boxShadow}
    }
  `}
  ${({borderRadius}) => `
    .ant-table-container{
      border-radius: ${borderRadius}!important;
      overflow:hidden;
    }
    .ant-table{
      border-radius: ${borderRadius}!important;
    }
  `}
  .ant-table-placeholder .ant-table-cell {
    border: none !important;
    background: white !important;
  }

  ${({variant, borderColor, borderWidth}) => `
    ${variant === "DEFAULT" || !variant ? `
      .ant-table-container {
        border: ${borderWidth ?? 1}px solid ${borderColor || '#f0f0f0'}!important;
      }

      .ant-table-cell {
        border-left: ${borderWidth ?? 1}px solid ${borderColor || '#f0f0f0'}!important;
        border-bottom: ${borderWidth ?? 1}px solid ${borderColor || '#f0f0f0'}!important;
      }

      .ant-table-cell:first-child{
        border-left: none!important;
      }

      .ant-table-row:last-child .ant-table-cell{
        border-bottom: none!important;
      }
    ` : ``}
  `}
  ${({variant, borderColor, borderWidth}) => `
    ${variant === "VARIANT3" ? `
      .ant-table-thead .ant-table-cell,.ant-table-tbody .ant-table-row .ant-table-cell{
        border-bottom: ${borderWidth ?? 1}px solid ${borderColor || '#f0f0f0'}!important;
      }
    ` : ``}
  `}
  .ant-table-cell-row-hover {
    background: ${({
                     backgroundMouseOver,
                     backgroundBody1
                   }) => backgroundMouseOver == "transparent" ? backgroundBody1 : backgroundMouseOver} !important;
  }

  .ant-table-expanded-row-fixed {
    background: ${({backgroundBody1}) => backgroundBody1} !important;
  }

  ${({isZebraStripe, backgroundBody1, backgroundBody2, backgroundMouseOver}) => `
    ${`

    tr:nth-child(odd){
      background: ${backgroundBody1};
      td.ant-table-cell-fix-left-last,td.ant-table-cell-fix-right-first
      {
        background: ${backgroundBody1};
      }
    }

    tr:nth-child(even){
      background: ${isZebraStripe ? backgroundBody2 : backgroundBody1};
      td.ant-table-cell-fix-left-last,td.ant-table-cell-fix-right-first
      {
        background: ${isZebraStripe ? backgroundBody2 : backgroundBody1};
      }
    }
    `}
  `}
  .tableDataCellCz {
    display: flex;
    padding: 0 8px 8px 8px !important;

    & > div {
      margin-top: 8px !important;
    }
  }

  .ant-pagination {
    padding-right: 8px;

    .ant-pagination-item-active a {
      color: ${({accentColor}) => accentColor} !important;
    }

    .ant-pagination-item-link {
      color: ${({accentColor}) => accentColor} !important;
    }
  }

  .ant-pagination-item-active {
    border-color: ${({accentColor}) => accentColor} !important;
  }

  .thAlignLeft {
    text-align: left !important;
  }

  .thAlignCenter {
    text-align: center !important;
  }

  .thAlignRight {
    text-align: right !important;
  }
`;

export const ITEM_OPERATION = "--operation--";

const EditableTable = (props: any) => {
  const {
    compactMode,
    isDisabled,
    isLoading,
    isRequired,
    labelAlignment,
    labelPosition,
    labelStyle,
    labelTextColor,
    labelTextSize,
    labelTooltip,
    labelWidth,
    label,
    onValueChange,
    onFormValuesChange,
    tableColumns,
    tableAction,
    tableColumnsMap,
    upTableColumnsMap,
    selectId,
    onOptionChange,
    tableSize,
    textSizeHead,
    textColorHead,
    fontStyleHead,
    horizontalAlignmentHead,
    backgroundHead,
    textSizeBody,
    textColorBody,
    fontStyleBody,
    horizontalAlignmentBody,
    borderRadius,
    boxShadow,
    variant,
    borderColor,
    borderWidth,
    backgroundMouseOver,
    isZebraStripe,
    backgroundBody1,
    backgroundBody2,
    newBtnType,
    newBtnColor,
    newBtnFontStyle,
    newBtnTextSize,
    newBtnBgColor,
    newBtnBorderRadius,
    newBtnBoxShadow,
    opBtnType,
    opBtnColor,
    opBtnBgColor,
    opBtnFontStyle,
    opBtnTextSize,
    opBtnBorderRadius,
    opBtnBoxShadow,
    accentColor,
    subCellEvents,
    onSaveCompleteChange,
    onSetEditKey,
    maxCount,
    tableActionNo,
    actionCollapseIconColor,
    onCellClick,
    addNewBtnVisible,
    newLinePosition,
    isPagination,
    pageSizeOptions,
    paginationChange,
    currPage,
    pageSize,
    total,
    tableData,
    onAddNewRowLinkageEvent,
    updateWidgetMetaProperty,
    onBatchSaveLinkageEvent,
    onBatchDeleteLinkageEvent,
    doOnBatchDeleteLinkageEvent,
    doOnBatchSaveLinkageEvent,
    widgetName,
  } = props;
  //列处理

  const onValChange = (value: any) => {
    onValueChange(value)
  };
  const onSaveCompleteChangeEvent = (value: any) => {
    onSaveCompleteChange(value)
  };

  const onSelectOptionChange = (event: any, record: any) => {
    onOptionChange(event, record)
  };

  const dataCache = useRef([]);
  const dataCacheUUID = useRef([]);

  const getCols = (cols: any) => {
    let _cols: any = [];
    const _tableColumns: any = _.sortBy(Object.values(cols), ['index']);
    if (_tableColumns) {
      let keys = Object.keys(_tableColumns);
      for (let i = 0; i < keys.length; i++) {
        let _val: any = {..._tableColumns[keys[i]]};
        _val.title = _val.label;
        _val.dataIndex = _val.id;
        if (_val.columnType == "select") {
          _val.dataIndex = _val.id + ".value";
          _val.id =  _val.id + ".value";
        }
        _val.required = _val.isCellRequired;
        _val.onOptionChange = _val.onOptionChange || undefined;
        _val.inputType = _val.columnType;
        if (_val.width) {
          _val.width = parseInt(_val.width);
        } else {
          _val.flex = 1;
          _val.width = 150;
        }
        _val.editable = true;
        if (_val.isCellVisible != false) {
          _cols.push(_val);
        }
      }
    }
    return _cols;
  }

  const editRef = useRef<any>();

  const getDataSource = () => {
    let _tableData = _.cloneDeep(tableData || []);
    _tableData.forEach((item:any) => {
      delete item['--operation--'];
      delete item[SERVICE_BATCH_DATA];
    })
    if (_.isEqual(dataCache.current, _tableData)) {
      return dataCacheUUID.current;
    }
    let _data = _tableData || [];
    let _dataNew: any = [];
    _.each(_data, (i: any) => {
      let m: any = {...i};
      if (!m.hasOwnProperty("key")) {
        if (m.hasOwnProperty("id")) {
          m["key"] = m.id;
          m["_hasId"] = true;
        } else {
          m["key"] = uuid2()
          m["_hasId"] = false;
        }
      }
      _dataNew.push(m);
    })
    dataCache.current = _tableData;
    dataCacheUUID.current = _dataNew;
    return _dataNew;
  }

  return (
    <DivContainer
      compactMode={compactMode}
      data-testid="radiogroup-container"
      labelPosition={labelPosition}
      textSizeHead={textSizeHead}
      textColorHead={textColorHead}
      fontStyleHead={fontStyleHead}
      backgroundHead={backgroundHead}
      textSizeBody={textSizeBody}
      textColorBody={textColorBody}
      fontStyleBody={fontStyleBody}
      horizontalAlignmentBody={horizontalAlignmentBody}
      boxShadow={boxShadow}
      borderRadius={borderRadius}
      variant={variant}
      borderColor={borderColor}
      borderWidth={borderWidth}
      backgroundMouseOver={backgroundMouseOver}
      isZebraStripe={isZebraStripe}
      backgroundBody1={backgroundBody1}
      backgroundBody2={backgroundBody2}
      accentColor={accentColor}
    >
      {label && (
        <LabelWithTooltip
          className={`datepicker-label`}
          text={label}
          cyHelpTextClassName="datepicker-tooltip"
          alignment={labelAlignment}
          color={labelTextColor}
          compact={compactMode}
          disabled={isDisabled}
          fontSize={labelTextSize}
          fontStyle={labelStyle}
          helpText={labelTooltip}
          loading={isLoading}
          position={labelPosition}
          width={labelWidth}
          isRequired={isRequired}
        />
      )}
      <div style={{width: labelPosition == "Left" ? '80%' : '100%', flex: 1}}>
        <EditableTableComponent
          ref={editRef}
          isDisabled={isDisabled}
          selectId={selectId}
          onOptionChange={onSelectOptionChange}
          size={tableSize}
          newBtnType={newBtnType}
          newBtnColor={newBtnColor}
          newBtnFontStyle={newBtnFontStyle}
          newBtnTextSize={newBtnTextSize}
          newBtnBgColor={newBtnBgColor}
          newBtnBorderRadius={newBtnBorderRadius}
          newBtnBoxShadow={newBtnBoxShadow}
          opBtnType={opBtnType}
          opBtnColor={opBtnColor}
          opBtnBgColor={opBtnBgColor}
          opBtnFontStyle={opBtnFontStyle}
          opBtnTextSize={opBtnTextSize}
          opBtnBorderRadius={opBtnBorderRadius}
          opBtnBoxShadow={opBtnBoxShadow}
          tableColumns={tableColumns}
          tableAction={tableAction}
          tableColumnsMap={tableColumnsMap}
          upTableColumnsMap={upTableColumnsMap}
          boxShadow={boxShadow}
          borderRadius={borderRadius}
          accentColor={accentColor}
          cols={getCols(tableColumns)}
          onValChange={onValChange}
          onFormValuesChange={onFormValuesChange}
          onSaveCompleteChange={onSaveCompleteChangeEvent}
          onSetEditKey={onSetEditKey}
          data={getDataSource()}
          maxCount={maxCount}
          subCellEvents={subCellEvents}
          tableActionNo={tableActionNo}
          actionCollapseIconColor={actionCollapseIconColor}
          addNewBtnVisible={addNewBtnVisible}
          newLinePosition={newLinePosition}
          onCellClick={onCellClick}
          paginationChange={paginationChange}
          isPagination={isPagination}
          pageSizeOptions={pageSizeOptions}
          currPage={currPage}
          pageSize={pageSize}
          total={total}
          onAddNewRowLinkageEvent={onAddNewRowLinkageEvent}
          updateWidgetMetaProperty={updateWidgetMetaProperty}
          isRowSelection={props.isRowSelection}
          selectType={props.selectType}
          selectedIndex={props.selectedIndex}
          onRowSelection={props.onRowSelection}
          onBatchSaveLinkageEvent={onBatchSaveLinkageEvent}
          onBatchDeleteLinkageEvent={onBatchDeleteLinkageEvent}
          doOnBatchDeleteLinkageEvent={doOnBatchDeleteLinkageEvent}
          doOnBatchSaveLinkageEvent={doOnBatchSaveLinkageEvent}
          widgetName={widgetName}
        />
      </div>
    </DivContainer>
  )
}

class EditableTableWidgetComponent extends React.Component<any> {
  constructor(props: any) {
    super(props);
  }

  render() {
    return <EditableTable {...this.props} />;
  }
}

export default EditableTableWidgetComponent;
